import { Settings, WidgetData } from "./data"
import { Widget } from "./widget"

export type IconListData = WidgetData & {
  settings: Settings & {
    icon_list: Array<{ text: string /* TODO selected_icon */ }>,
  },
  widgetType: "icon-list"
}

export type IconListWidgetItem = {
  text: string,
}

export class IconListWidget extends Widget {
  items: Array<IconListWidgetItem>

  constructor(data: IconListData) {
    super(data);
    this.items = data.settings.icon_list.map(i => ({ text: i.text }));
  }
}

